import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';
import { conversation_interface, conversation_replies_interface } from 'src/core/interfaces/ticket.interface';
import { ChatRoomService } from 'src/services/chat-room/auth.service';
import { TicketService } from 'src/services/ticket/ticket.service';

@Component({
  selector: 'app-chat-room',
  templateUrl: './chat-room.component.html',
  styleUrls: ['./chat-room.component.css']
})
export class ChatRoomComponent implements OnInit {


  conversation : conversation_replies_interface[] = [];
  full_chat_data : conversation_interface;
  ticket_number: number;


  constructor(
    private active_r: ActivatedRoute,
    private ticket_s: TicketService,
    private chatroom_s: ChatRoomService 
  ) { }

  ngOnInit(): void 
  {

    // get chat room conversations
    this.get_conversation();

  }



  get_conversation()
  {

    this.active_r.params.subscribe(
      (params : any)=>{

        // save ticket id
        this.ticket_number = params.ticket_id;


        // get conversation for this ticket id
        this.get_conversation_please(params.ticket_id);
        


      },
      (err)=>{
        console.error(err);
      }
    );
    

  }


  get_conversation_please(ticket_id : number)
  {


    this.ticket_s.get_ticket_conversation(ticket_id).subscribe(
      (data : any)=>{

        // set data of replies
        this.conversation = data.data.replies;
        this.full_chat_data = data.data;

      },
      (err)=>{
        console.error(err);
      }
    );

  }




  send_reply(reply_text_input : HTMLTextAreaElement)
  {

    this.chatroom_s.send_user_reply(reply_text_input.value , this.ticket_number).subscribe(
      (data : any)=>{
        console.log(data);

        // get conversation for this ticket id
        this.get_conversation_please(this.ticket_number);

        // reset the text input
        reply_text_input.value = '';

      },
      (err)=>{
        console.error(err);
      }
    );

  }


}
